import React, { useState } from "react";
import AddModal from "../sections/modal/AddModal";
import { IService } from "../../../@types";
import { CloseIcon } from "../../../assets/icons";
import ButtonCTA from "../../Reusable/ButtonCTA";
import { InputComponent } from "../../core/Forms";
import { formatCurrencyMoney } from "../../../utils";

interface IShowSelectedServiceItem {
  selectedService: IService;
  closeModal: () => void;
  handleSetFormData: (selectedService: IService) => void;
}
const ShowSelectedServiceItem = ({
  selectedService,
  closeModal,
  handleSetFormData,
}: IShowSelectedServiceItem) => {
  const [durations, setDurations] = useState("");

  const handleDoneClick = () => {
    const updatedServices = {
      ...selectedService,
      duration: durations,
    };
    handleSetFormData(updatedServices);
    closeModal();
  };

  const renderServiceDetails = () => {
    if (!selectedService) return null;

    const { name, price } = selectedService;
    return (
      <div
        className={`w-full border-[1.5px] rounded-[8px] bg-[#FCFCFD] p-2 mt-2`}
      >
        <div className="flex justify-between text-[14px] p-1">
          <p className="font-medium text-gray-800 leading-5">{name}</p>
        </div>
        <div className="flex gap-2 w-full mt-2">
          <InputComponent
            value={formatCurrencyMoney(price[0].amount)}
            className="w-full border border-gray-200 p-2 text-gray-400"
            name="price"
            disabled={true}
          />
          <InputComponent
            type="number"
            name="duration"
            value={durations}
            placeholder="Duration (Hours)"
            handleChange={(e) => {
              setDurations(e.target.value);
            }}
            className="w-full border border-gray-200 p-2 text-gray-400"
          />
        </div>
      </div>
    );
  };
  return (
    <AddModal>
      <div>
        <div className="flex justify-between items-center py-2">
          <p className="font-semibold text-[18px] leading-6 text-[#000]">
            Set Duration
          </p>
          <div onClick={closeModal}>
            <CloseIcon />
          </div>
        </div>

        {renderServiceDetails()}
        <div className="mt-5">
          <ButtonCTA
            variant="outline"
            className="w-full"
            disabled={false}
            onClick={() => handleDoneClick()}
          >
            Done
          </ButtonCTA>
        </div>
      </div>
    </AddModal>
  );
};

export default ShowSelectedServiceItem;
